import { createLogic } from "redux-logic";
import { type UscSetStepType, USC_NAV_SET_STEP } from "../actions/UscNavActions";
import type { UscLogicType } from "../store";

const setStepLogic = (createLogic as UscLogicType<UscSetStepType>)({
    type: USC_NAV_SET_STEP,

    process(_, _dispatch, done) {
        // This assumes the USC component is the only component on the page which it should be in its current form.
        window.scrollTo(0, 0);
        done();
    },
});

export default [setStepLogic];
